module.exports = __webpack_public_path__ + "static/valori_small-aa2e4534c4c3ad30a325a818b819f447.jpg";